import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout';

const { Title } = Typography;

export default function TermsAndConditionsPage() {
  const navigate = useNavigate();

  const cardStyle = {
    width: '100%',
    maxWidth: 800,
    borderRadius: 16,
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  };

  return (
    <AuthLayout>
      <Card
        style={cardStyle}
        bodyStyle={{ padding: 32 }}
        title={
          <Space>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/login')}
              style={{ padding: 0, marginRight: 8 }}
            />
            <Title level={3} style={{ margin: 0 }}>
              Términos y Condiciones
            </Title>
          </Space>
        }
      >
        <div style={{ lineHeight: 1.8, color: '#262626' }}>
        </div>

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/login')}
            size="large"
          >
            Regresar al Login
          </Button>
        </div>
      </Card>
    </AuthLayout>
  );
}

